<template>
  <div class="d-flex flex-column h-100">
    <Header  />
    <Sidemenu @callMenu="callMenu()" />
    <div class="content">
      <main class="h-100">
        <router-view v-if="showRoueter"/>

        <template v-if="!showRoueter" >
          <div class="text-center logo-container" @click="MoveToHome()">
            <img @click="MoveToHome()" src="./assets/img/heybourne-splash.png" alt="Heybourne Park Logo" class="logo" />
            <div class="RightSide"></div>
          </div>
        </template>
      </main>
    </div>
    <div class="footer fixed-bottom" v-if="showRoueter">
      <Footer @toggle-menu="callMenu()" />
    </div>  
  </div>
</template>


<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Sidemenu from "@/components/Sidemenu.vue";


export default {
  name: "HomeView",
  components: {
    Header,
    Footer,
    Sidemenu
  },
  data(){
    return {
        pagename: "",
        showRoueter: false,
    }
  },
  created(){
    document.title = "Heybourne Park";
    this.StartSession();
    setTimeout(()=>{
      //this.showRoueter = true;
    }, 3000)
  },
  methods: {
    callMenu: () => {
      if (document.getElementById('mySidenav').offsetWidth == 0) {
        document.getElementById('mySidenav').style.width = "250px";
      } else {
        document.getElementById('mySidenav').style.width = "0px";
      }
    },
    Specs(res){
      this.pagename = res;
    },
    MoveToHome(){
      this.showRoueter = true;
      console.log(this.showRoueter)
    },
    StartSession(){
     
      if(sessionStorage.getItem('session_id') == null){
            let data = { 
                session_id: sessionStorage.getItem('session_id')
            }
            fetch(this.base_url+'StartSession',{
                method: 'POST', // or 'PUT'
                headers: {
                    
                },
                body: JSON.stringify(data),
                })
            .then(response => response.json())
            .then(res => {
                console.log('new '+res.data.session_id);
                sessionStorage.setItem('session_id', res.data.session_id);
            });
      }else{
        console.log('old '+sessionStorage.getItem('session_id'));
      }
    },

  }
};
</script>

<style lang="scss" scoped>

.content{
    height: calc(100% - 70px);
}

.footer{
  min-height: 70px;
}

.logo-container{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #7da9a9;
  background: url('./assets/img/heybourne-splash-bg.png');
  flex-direction: column;
  h3{
    width:100%;
    display:block;
    color:#fff;
    letter-spacing: 2.5px;
    position: relative;
    z-index: 2;
    font-size: 23px;
    font-weight: 600;
  }
  .logo{
    height: 50% ;
    position: relative;
    z-index: 2;
  }
}

// .RightSide{
//   width:50%;
//   height: 100vh;
//   position: absolute;
//   background: url('https://heybournepark.qtcloud.co.uk/apartment-assets/heybourne-splash-bg.png');
//   right: 0;
//   z-index: 0;
// }

.cursor-pointer {
  cursor:pointer;
}

@media screen and (max-width: 800px) {
  .logo-container{
    h3{
      font-size: 18px;
    }
    .logo{
      width: 90%;
      height: auto !important;
    }
  }

  .logo-container {
    height: calc(100vh - 70px);
    margin-top: 70px;
  }

}
</style>

